import React from 'react';
import { Form, Input, Switch, Card, Space } from 'antd';

export default function NotificationPreferences({ form }) {
  return (
    <div>
      <Card title="Communication Settings" className="mb-4">
        <Form.Item
          name="senderLabel"
          label="Preferred Sender Label"
          rules={[{ required: true, message: 'Please enter sender label' }]}
          tooltip="This label will be used for SMS and email communications"
        >
          <Input placeholder="e.g., ACME-OPS" />
        </Form.Item>


      </Card>

      <Card title="Alert Preferences">
        <Space direction="vertical" style={{ width: '100%' }}>
          <Form.Item
            name="alertTaskUpdates"
            label="CMT Task Updates"
            valuePropName="checked"
            tooltip="Receive notifications for task updates"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            name="alertIncidentEscalations"
            label="Incident Escalations"
            valuePropName="checked"
            tooltip="Receive notifications for incident escalations"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            name="alertThreatFeeds"
            label="Threat Feed Updates"
            valuePropName="checked"
            tooltip="Receive notifications for relevant threat feed updates"
          >
            <Switch />
          </Form.Item>
        </Space>
      </Card>
    </div>
  );
} 